import "./HplcSustainabilityKnowledgeCentre.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ResourceTypes from "./sections/ResourceTypes";
import RelatedSolutions from "./sections/RelatedSolutions";
import Footer from "@/reusable_sections/Footer";
export default function HplcSustainabilityKnowledgeCentrePage() {
  return <div>
      <Header />
      <Hero />
      <ResourceTypes />
      <RelatedSolutions />
      <Footer />
    </div>;
}